import VacationEdit from './VacationEdit';
import Attendance from './Attendance';
import FaceRegister from './FaceRegister';

const ACTION = {
  ...VacationEdit.ACTION,
  ...Attendance.ACTION,
  ...FaceRegister.ACTION,
};

const ACTION_TYPES = {
  ...VacationEdit.ACTION_TYPES,
  ...Attendance.ACTION_TYPES,
  ...FaceRegister.ACTION_TYPES,
};

const Exam = {
  ACTION,
  ACTION_TYPES
}

export default Exam;